import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { COUNTDOWN } from '~/constants'
dayjs.extend(customParseFormat)

export function useCountdown() {
  const countdownNumber = reactive({
    hours: COUNTDOWN.DOUBLE_ZERO,
    minutes: COUNTDOWN.DOUBLE_ZERO,
    seconds: COUNTDOWN.DOUBLE_ZERO
  })

  function calculateCountdown(time: string): void {
    const [h, m, s] = time.split(':')
    const MILLISECONDS_PER_HOUR = 1000 * 60 * 60
    const MILLISECONDS_PER_MINUTE = 1000 * 60
    let targetTime = dayjs()
      .set('hour', h as unknown as number)
      .set('minute', m as unknown as number)
      .set('second', s as unknown as number)
    let timeDifference = targetTime.valueOf() - dayjs().valueOf()
    if (timeDifference < 0) {
      targetTime = dayjs(targetTime).set('date', dayjs(targetTime).get('date') + 1)
      timeDifference = targetTime.valueOf() - dayjs().valueOf()
    }
    countdownNumber.hours = Math.floor(timeDifference / MILLISECONDS_PER_HOUR)
      .toString()
      .padStart(2, COUNTDOWN.ZERO)
    countdownNumber.minutes = Math.floor((timeDifference % MILLISECONDS_PER_HOUR) / MILLISECONDS_PER_MINUTE)
      .toString()
      .padStart(2, COUNTDOWN.ZERO)
    countdownNumber.seconds = Math.floor((timeDifference % MILLISECONDS_PER_MINUTE) / 1000)
      .toString()
      .padStart(2, COUNTDOWN.ZERO)
  }

  return {
    countdownNumber,
    calculateCountdown
  }
}
